import React from 'react';
import PropTypes from 'prop-types';

import FileUpload from 'components/FileUpload';

import { UPLOAD_IMAGE_URL } from 'consts';
import { UPLOAD_IMAGE_MAX_SIZE } from 'consts/upload';

class ImageUpload extends React.PureComponent {
  render() {
    const {
      image,
      onChange,
      onFileUpload,
      placeholder,
      label,
      disabled,
    } = this.props;
    return (
      <FileUpload
        file={image}
        disabled={disabled}
        onChange={onChange}
        onFileUpload={onFileUpload}
        placeholder={placeholder}
        label={label}
        uploadURL={UPLOAD_IMAGE_URL}
        maxSize={UPLOAD_IMAGE_MAX_SIZE}
      />
    );
  }
}

ImageUpload.propTypes = {
  image: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
};

export default ImageUpload;
